import {useEffect, useLayoutEffect} from 'react';
import {useLocation} from 'react-router-dom';

/**
 * Прокручивает страницу в начало при переходе на новый маршрут.
 */
export default function ScrollToTop() {
    const {pathname} = useLocation();

    useEffect(() => {
        const previousScrollRestoration = window.history.scrollRestoration;
        window.history.scrollRestoration = 'manual';

        return () => {
            window.history.scrollRestoration = previousScrollRestoration;
        };
    }, []);

    useLayoutEffect(() => {
        window.scrollTo(0, 0);
    }, [pathname]);

    return null;
}
